import React, { ChangeEvent, forwardRef, ReactElement, useState } from 'react';
import styled from '@emotion/styled';
import { Textarea as _Textarea } from '@bucketplace/commerce-admin-ui';
import { ODS_FONT_STYLE } from '@bucketplace/design-system';

const MAX_ROWS = 3;

interface URLInputProps {
  value: string;
  placeholder?: string;
  readOnly?: boolean;
  onChange?: (value: string) => void;
  onBlur?: () => void;
}

export const URLInput = forwardRef<HTMLTextAreaElement, URLInputProps>(({
  value,
  placeholder,
  readOnly,
  onChange,
  onBlur,
}, ref): ReactElement => {
  const [maxRows, setMaxRows] = useState<number | undefined>(MAX_ROWS);

  return (
    <Textarea
      ref={ref}
      value={value ?? ''}
      maxRows={readOnly ? MAX_ROWS : maxRows}
      autoHeight
      readOnly={readOnly}
      placeholder={placeholder}
      onFocus={() => setMaxRows(undefined)}
      onChange={(event) => {
        const value = (event as unknown as ChangeEvent<HTMLTextAreaElement>).target.value.replace(/\s/g, '');
        onChange?.(value);
      }}
      onBlur={() => {
        setMaxRows(MAX_ROWS);
        onBlur?.();
      }}
    />
  );
});

const Textarea = styled(_Textarea)<{ maxRows?: number }>`
  padding-top: 0;
  padding-bottom: 0;

  > textarea {
    ${ODS_FONT_STYLE.body14L20};
    ${({ maxRows }) => !!maxRows && `
      max-height: ${maxRows * 20}px;
    `}
  }
`;
